import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, Store } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function SettingsPage() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: "",
    legal_name: "",
    address: "",
    phone: "",
    email: "",
    npwp: "",
  });

  useEffect(() => {
    api.get("/shop").then((r) => {
      setForm({
        name: r.data.name || "",
        legal_name: r.data.legal_name || "",
        address: r.data.address || "",
        phone: r.data.phone || "",
        email: r.data.email || "",
        npwp: r.data.npwp || "",
      });
    }).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/settings/shop", form);
      toast.success("Pengaturan toko disimpan");
    } catch (err) {
      const d = err?.response?.data?.detail || "Gagal";
      toast.error(typeof d === "string" ? d : "Gagal");
    } finally {
      setSaving(false);
    }
  };

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="max-w-2xl mx-auto space-y-5" data-testid="settings-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Pengaturan Toko</h1>
        <p className="text-sm text-slate-500 mt-1">Info toko akan tampil di header aplikasi dan nota cetak.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5 space-y-4">
        <div className="flex items-center gap-2 mb-1">
          <Store className="w-4 h-4 text-blue-600" />
          <span className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Informasi Toko</span>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>Nama Toko</Label>
            <Input value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="settings-name" placeholder="Rizki Service" />
          </div>
          <div>
            <Label>Nama Badan Hukum</Label>
            <Input value={form.legal_name} onChange={(e) => set("legal_name", e.target.value)} data-testid="settings-legal-name" placeholder="PT Rizki Teknologi Maju" />
          </div>
          <div>
            <Label>No. Telepon</Label>
            <Input value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="settings-phone" placeholder="0852-8960-3108" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="settings-email" placeholder="info@rtmsystem.online" />
          </div>
          <div className="md:col-span-2">
            <Label>Alamat Lengkap</Label>
            <Textarea rows={3} value={form.address} onChange={(e) => set("address", e.target.value)} data-testid="settings-address" placeholder="Jalan, blok, nomor, kecamatan, kabupaten/kota, kode pos" />
          </div>
          <div>
            <Label>NPWP</Label>
            <Input value={form.npwp} onChange={(e) => set("npwp", e.target.value)} data-testid="settings-npwp" placeholder="00.000.000.0-000.000" />
          </div>
        </div>

        <div className="pt-2 border-t border-slate-100">
          <Button onClick={save} disabled={saving} data-testid="settings-save-btn" className="bg-slate-900 gap-2">
            <Save className="w-4 h-4" /> {saving ? "Menyimpan..." : "Simpan Pengaturan"}
          </Button>
        </div>
      </div>
    </div>
  );
}
